var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button d-flex flex-sm-row flex-column justify-content-between"},[_c('ebp-button',{attrs:{"size":"sm"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"bx bx-arrow-back mr-2"}),_vm._v(_vm._s(_vm.$t("back")))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }